import { Box } from "@mui/material";
import { brown } from "@mui/material/colors";
import React from "react";

import { styled, alpha } from "@mui/material/styles";
import { SimpleTreeView } from "@mui/x-tree-view/SimpleTreeView";
import { TreeItem, treeItemClasses } from "@mui/x-tree-view/TreeItem";
import InitVars from "../../src/InitVars";

const SidebarOfficer = React.memo(() => {
  const CustomTreeItem = styled(TreeItem)(({ theme }) => ({
    color: brown[100],
    [`& .${treeItemClasses.content}`]: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.2, 0),
      [`& .${treeItemClasses.label}`]: {
        fontSize: "0.8rem",
        fontWeight: 500,
      },
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      borderRadius: "50%",
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(0, 1.2),
      ...theme.applyStyles("light", {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      }),
      ...theme.applyStyles("dark", {
        color: theme.palette.primary.contrastText,
      }),
    },
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 10,
      paddingLeft: 5,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    ...theme.applyStyles("light", {}),
  }));

  const CustomTreeItemGroupHeader = styled(TreeItem)(({ theme }) => ({
    color: brown[400],
    [`& .${treeItemClasses.content}`]: {
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0.5, 1),
      margin: theme.spacing(0.2, 0),
      [`& .${treeItemClasses.label}`]: {
        fontSize: "0.8rem",
        fontWeight: 500,
      },
    },
    [`& .${treeItemClasses.iconContainer}`]: {
      borderRadius: "50%",
      backgroundColor: theme.palette.primary.dark,
      padding: theme.spacing(0, 1.2),
      ...theme.applyStyles("light", {
        backgroundColor: alpha(theme.palette.primary.main, 0.25),
      }),
      ...theme.applyStyles("dark", {
        color: theme.palette.primary.contrastText,
      }),
    },
    [`& .${treeItemClasses.groupTransition}`]: {
      marginLeft: 10,
      paddingLeft: 5,
      borderLeft: `1px dashed ${alpha(theme.palette.text.primary, 0.4)}`,
    },
    ...theme.applyStyles("light", {}),
  }));

  const [expandedItems, setExpandedItems] = React.useState<string[]>([
    "officer",
  ]);

  const handleExpandedItemsChange = (
    event: React.SyntheticEvent,
    itemIds: string[]
  ) => {
    setExpandedItems(itemIds);
  };

  return (
    <div className="sidebar">
      <Box
        sx={{
          height: "94vh",
          borderRight: 1,
          borderColor: brown[900],
          paddingLeft: 1,
        }}
      >
        <SimpleTreeView
          expandedItems={expandedItems}
          onExpandedItemsChange={handleExpandedItemsChange}
        >
          <CustomTreeItemGroupHeader itemId="officer" label="Officer">
            {/* <CustomTreeItem itemId="grid-community" label="@mui/x-data-grid" />
            <CustomTreeItem itemId="grid-pro" label="@mui/x-data-grid-pro" /> */}
            <CustomTreeItem
              itemId="officeroption"
              label="Officer Option"
              onClick={(e) => (InitVars.sidebarOption = "")}
            />
            <CustomTreeItem
              itemId="officerplayerlist"
              label="Player List"
              onClick={(e) => (InitVars.sidebarOption = "OfficerPlayerList")}
            />
          </CustomTreeItemGroupHeader>
          {/* <CustomTreeItemGroupHeader
            itemId="pickers"
            label="Date and Time Pickers"
          >
            <CustomTreeItem
              itemId="pickers-community"
              label="@mui/x-date-pickers"
            />
            <CustomTreeItem
              itemId="pickers-pro"
              label="@mui/x-date-pickers-pro"
            />
          </CustomTreeItemGroupHeader>
          <CustomTreeItemGroupHeader itemId="charts" label="Charts">
            <CustomTreeItem itemId="charts-community" label="@mui/x-charts" />
          </CustomTreeItemGroupHeader>
          <CustomTreeItemGroupHeader itemId="tree-view" label="Tree View">
            <CustomTreeItem
              itemId="tree-view-community"
              label="@mui/x-tree-view"
            />
          </CustomTreeItemGroupHeader> */}
        </SimpleTreeView>
      </Box>
    </div>
  );
});

export default React.memo(SidebarOfficer);
